import type { ComponentPropsWithRef } from 'react';

import * as Sentry from '@sentry/browser';
import { ErrorBoundary } from 'react-error-boundary';

type ErrorInfo = {
  componentStack: string;
};

type ErrorHandler = (error: Error, info: ErrorInfo) => void;

type ErrorBoundaryProps = ComponentPropsWithRef<typeof ErrorBoundary> & {
  onError?: ErrorHandler;
};

export const ErrorBoundaryComponent = ({ onError, ...restProps }: ErrorBoundaryProps) => {
  const handleLoggedError: ErrorHandler = (error, info) => {
    Sentry.captureException(error);

    if (onError) {
      (onError as ErrorHandler)(error, info);
    }
  };

  return <ErrorBoundary {...restProps} onError={handleLoggedError} />;
};
